import type { ClientSideEventDef } from "./types";

export const CLIENT_SIDE_EVENTS: ClientSideEventDef[] = [
  {
    key: "productView",
    label: "Product view",
    help: "Triggered when an identified user views a product page.",
  },
  {
    key: "cartUpdate",
    label: "Cart update",
    help: "Triggered when an identified user updates their cart.",
  },
];
